import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "spin"
}
const _hoisted_3 = { class: "spin" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, {
            class: "ion-no-padding",
            fixed: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, { style: {"--min-height":"36px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_buttons, { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        slot: "icon-only",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_title, { style: {"padding-right":"0"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                          _createElementVNode("h2", null, [
                            _createElementVNode("b", null, "AchieveJUPAS Statistics")
                          ], -1)
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_toolbar, { style: {"--min-height":"24px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_segment, {
                    mode: "ios",
                    modelValue: _ctx.selectedSection,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedSection) = $event))
                  }, {
                    default: _withCtx(() => [
                      (_ctx.user.schoolId)
                        ? (_openBlock(), _createBlock(_component_ion_segment_button, {
                            key: 0,
                            value: "school",
                            disabled: _ctx.schoolChartFilters.loadingData
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.user.schoolId.toUpperCase()) + " ", 1),
                              (_ctx.schoolChartFilters.numOfStudents && _ctx.selectedSection == 'school')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_1, "(" + _toDisplayString(_ctx.schoolChartFilters.numOfStudents) + " students)", 1))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["disabled"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_segment_button, { value: "myself" }, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createTextVNode(" Myself ")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _withDirectives(_createVNode(_component_ion_toolbar, { style: {"--min-height":"24px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, { size: "6" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_select, {
                            fill: "solid",
                            label: "DSE year(s)",
                            "label-placement": "floating",
                            interface: "popover",
                            modelValue: _ctx.schoolChartFilters.yearDSE,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.schoolChartFilters.yearDSE) = $event)),
                            onIonChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.renderSchoolMockJUPASCharts()))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([_ctx.getF6YearDSE()-2, _ctx.getF6YearDSE()-1, _ctx.getF6YearDSE(), _ctx.getF6YearDSE()+1, _ctx.getF6YearDSE()+2], (year) => {
                                return (_openBlock(), _createBlock(_component_ion_select_option, {
                                  key: year,
                                  value: year
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(year), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, { size: "6" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_select, {
                            fill: "solid",
                            label: "Band(s)",
                            "label-placement": "floating",
                            interface: "popover",
                            modelValue: _ctx.schoolChartFilters.bandOrders,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.schoolChartFilters.bandOrders) = $event)),
                            multiple: "",
                            onIonDismiss: _cache[5] || (_cache[5] = ($event: any) => (_ctx.renderSchoolMockJUPASCharts()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_select_option, { value: "1" }, {
                                default: _withCtx(() => _cache[8] || (_cache[8] = [
                                  _createTextVNode("A1")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "2" }, {
                                default: _withCtx(() => _cache[9] || (_cache[9] = [
                                  _createTextVNode("A2")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: "3" }, {
                                default: _withCtx(() => _cache[10] || (_cache[10] = [
                                  _createTextVNode("A3")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512), [
                [_vShow, _ctx.selectedSection == 'school']
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_ion_spinner)
              ]))
            : (_openBlock(), _createBlock(_component_ion_grid, {
                key: 1,
                class: "ion-no-padding",
                fixed: ""
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("div", null, [
                    _createVNode(_component_ion_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, { size: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_list_header, {
                              color: "primary",
                              style: {"font-size":"18px","font-weight":"500"}
                            }, {
                              default: _withCtx(() => _cache[11] || (_cache[11] = [
                                _createTextVNode("Universities / Institutions")
                              ])),
                              _: 1
                            }),
                            _cache[12] || (_cache[12] = _createElementVNode("div", {
                              class: "chart",
                              id: "myself-chartdiv1"
                            }, null, -1))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_col, { size: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_list_header, {
                              color: "primary",
                              style: {"font-size":"18px","font-weight":"500"}
                            }, {
                              default: _withCtx(() => _cache[13] || (_cache[13] = [
                                _createTextVNode("Discipline Groups")
                              ])),
                              _: 1
                            }),
                            _cache[14] || (_cache[14] = _createElementVNode("div", {
                              class: "chart",
                              id: "myself-chartdiv2"
                            }, null, -1))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_list_header, {
                      color: "primary",
                      style: {"font-size":"18px","font-weight":"500"}
                    }, {
                      default: _withCtx(() => _cache[15] || (_cache[15] = [
                        _createTextVNode("Best 5 Median")
                      ])),
                      _: 1
                    }),
                    _cache[16] || (_cache[16] = _createElementVNode("div", {
                      class: "chart",
                      id: "myself-chartdiv3"
                    }, null, -1))
                  ], 512), [
                    [_vShow, _ctx.selectedSection == 'myself']
                  ]),
                  _withDirectives(_createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_ion_spinner)
                    ], 512), [
                      [_vShow, _ctx.schoolChartFilters.loadingData]
                    ]),
                    _withDirectives(_createElementVNode("div", null, [
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, { size: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_list_header, {
                                color: "primary",
                                style: {"font-size":"18px","font-weight":"500"}
                              }, {
                                default: _withCtx(() => _cache[17] || (_cache[17] = [
                                  _createTextVNode("Universities / Institutions")
                                ])),
                                _: 1
                              }),
                              _cache[18] || (_cache[18] = _createElementVNode("div", {
                                class: "chart",
                                id: "school-chartdiv1"
                              }, null, -1))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, { size: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_list_header, {
                                color: "primary",
                                style: {"font-size":"18px","font-weight":"500"}
                              }, {
                                default: _withCtx(() => _cache[19] || (_cache[19] = [
                                  _createTextVNode("Discipline Groups")
                                ])),
                                _: 1
                              }),
                              _cache[20] || (_cache[20] = _createElementVNode("div", {
                                class: "chart",
                                id: "school-chartdiv2"
                              }, null, -1))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_list_header, {
                        color: "primary",
                        style: {"font-size":"18px","font-weight":"500"}
                      }, {
                        default: _withCtx(() => _cache[21] || (_cache[21] = [
                          _createTextVNode("Most Selected Programs")
                        ])),
                        _: 1
                      }),
                      _cache[22] || (_cache[22] = _createElementVNode("div", {
                        class: "chart",
                        id: "school-chartdiv3"
                      }, null, -1))
                    ], 512), [
                      [_vShow, !_ctx.schoolChartFilters.loadingData]
                    ])
                  ], 512), [
                    [_vShow, _ctx.selectedSection == 'school']
                  ])
                ]),
                _: 1
              }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}